<template>
    <div class="_page" v-if="pageMsg.total>0">
        <div class="block">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageMsg.current_page"
                :page-size="pageMsg.per_page"
                background
                layout="prev, pager, next, jumper"
                :total="pageMsg.total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        };
    },
    props:['pageMsg'],
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.$emit('CurrentChangeFun', val);
        }
    }
};
</script>


<style>
._page {
  text-align: right;
  margin: 20px 0;
}
._page .el-pagination .el-pager .active {
  background: black !important;
}
._page .el-pagination .el-pager .number {
  background: white;
  border: 1px solid #eee;
}
.btn-prev,.btn-next{
  background: white !important
}
.el-icon-more{
  background: white !important
}
</style>